import { io } from 'socket.io-client';

let socket = null;

// The backend serves the API at REACT_APP_API_BASE_URL (e.g. .../api).
// Socket.io connects to the server root, so strip the /api suffix.
function socketBaseUrl() {
  const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api';
  return apiBase.replace(/\/api\/?$/, '');
}

export function getSocket() {
  if (socket) return socket;
  const token = localStorage.getItem('gmwc_token');
  socket = io(socketBaseUrl(), {
    auth: { token },
    autoConnect: false,
  });
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
